import { IconConfig } from '../../types';
import DefaultIconWithLoader from './components/DefaultIconWithLoader';
import RetryIconWithLoader from './components/RetryIconWithLoader';
import DeleteIcon from './DeleteIcon';

const IconWithLoader = ({ retryContent, deleteIcon, ...other }: IconConfig) => {
  if (retryContent) {
    return <RetryIconWithLoader retryContent={retryContent} {...other} />;
  }

  if (deleteIcon) {
    return <DeleteIcon id={other?.options?.id} {...other} />;
  }

  return <DefaultIconWithLoader {...other} />;
};

export default IconWithLoader;
